import { controls, currencyToNumber, grouped } from "../../controls";

const rpad18 = {
  label: "Branch Inspection Status",
  starting: true,
  url: "rp101m",
  pageLabel: "Branch Inspection Status",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Inspection Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "inspection_master_code", width: "col-sm-2", controlType: "InspectionMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Branch Inspection Status",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["total", "incomplete", "not_started", "in_progress", "almost_complete", "complete", "yes", "no"],
      grandtotal: { type: "fixed", displayIn: "display_label", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Inspection Name",
        accessor: "display_label",
        rwidth: "*"
      },
      {
        Header: "Total",
        accessor: "total"
      },
      {
        Header: "Incomplete",
        accessor: "incomplete"
      },
      {
        Header: "Not Started",
        accessor: "not_started"
      },
      {
        Header: "In Progress",
        accessor: "in_progress"
      },
      {
        Header: "Almost Complete",
        accessor: "almost_complete"
      },
      {
        Header: "Complete",
        accessor: "complete"
      },
      {
        Header: "YES",
        accessor: "yes"
      },
      {
        Header: "NO",
        accessor: "no"
      }
    ]
  }
};

export default rpad18;